import type { IPropertyVersion } from '@app/land-hold/property/models/PropertyVersion';
import { PropertyVersion } from '@app/land-hold/property/models/PropertyVersion';
import type { ComputedRef } from 'vue';

export function useVersionSelector(versions: ComputedRef<IPropertyVersion[]>) {
    const selectedVersionId = ref<string | null>(null);

    watchEffect(() => {
        if (versions.value.length > 0 && selectedVersionId.value === null) {
            selectedVersionId.value = versions.value[0]?.id ?? null;
        }
    });

    const selectedVersion = computed<IPropertyVersion | undefined>(() => {
        return versions.value.find((v) => v.id === selectedVersionId.value);
    });

    const versionDropdownItems = computed(() => {
        return versions.value.map((v) => ({
            id: v.id,
            label: PropertyVersion.getDropdownLabel(v),
        }));
    });

    return {
        selectedVersionId,
        selectedVersion,
        versionDropdownItems,
    };
}
